<template>
  <div class="user-wrapper">
    <div class="content-box">
      <!-- TODO -->
      <a href="https://pro.loacg.com/docs/getting-started" target="_blank" style="display:none;">
        <span class="action">
          <a-icon type="question-circle-o"></a-icon>
        </span>
      </a>
      <!-- TODO -->
      <notice-icon class="action"/>
      <a-dropdown>
        <span class="action ant-dropdown-link user-dropdown-menu">
          <span class="avatar ant-avatar ant-avatar-sm ant-avatar-circle ant-avatar-image"><img :src="avatarId() | buildFile"></span>
          <span>{{ account() }}</span>
        </span>
        <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
          <!-- <a-menu-item key="0">
            <router-link :to="{ name: 'personalinf' }">
              <a-icon type="user"/>
              <span>个人中心</span>
            </router-link>
          </a-menu-item> -->
          <!-- <a-menu-item key="1">
            <router-link :to="{ name: 'mediainf' }">
              <a-icon type="setting"/>
              <span>账户设置</span>
            </router-link>
          </a-menu-item> -->
          <a-menu-item key="1" >
            <div @click="visible = true">
              <a-icon type="lock"/>
              <span style="margin-left:8px;">修改密码</span>
            </div>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="2" >
            <div @click="downloadSetup">
              <a-icon type="cloud-download" />
              <span style="margin-left:8px;">打印驱动</span>
            </div>
          </a-menu-item>
          <a-menu-divider/>
          <a-menu-item key="3">
            <a href="javascript:;" @click="handleLogout">
              <a-icon type="logout"/>
              <span>退出登录</span>
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <a-modal
      title="修改密码"
      v-model="visible"
      @ok="handleOk"
    >
      <a-row class="form-row" :gutter="16">
        <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
          <a-form-item
            label="输入旧密码"
            :labelCol="{lg: {span: 4}, sm: {span: 4}}"
            :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
            <a-input type="password" v-model="passwdData.oldPassword"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="16">
        <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
          <a-form-item
            label="输入新密码"
            :labelCol="{lg: {span: 4}, sm: {span: 4}}"
            :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
            <a-input type="password" v-model="passwdData.newPassword"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="16">
        <a-col :xl="{span: 24}" :lg="{span: 24}" :md="{span: 24}" :sm="24">
          <a-form-item
            label="确认新密码"
            :labelCol="{lg: {span: 4}, sm: {span: 4}}"
            :wrapperCol="{lg: {span: 16}, sm: {span: 16} }">
            <a-input type="password" v-model="passwdData.checkNewPassword"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import { updatePasswd } from '@/api/account'
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
import notification from 'ant-design-vue/es/notification'
import { passwordEncryption } from '@/utils/util'
import { downloadFile } from '@/utils'

export default {
  name: 'UserMenu',
  components: {
    NoticeIcon
  },
  data () {
    return {
      visible: false,
      passwdData: {
        id: '',
        oldPassword: '',
        newPassword: '',
        checkNewPassword: '',
        loginTime: String((new Date()).getTime())
      }
    }
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['account', 'avatarId', 'accountId']),
    // 下载打印驱动
    downloadSetup() {
      // window.location.href =
      //   'https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/%E6%89%93%E5%8D%B0%E6%9C%BA%E5%AE%89%E8%A3%85%E5%8C%85.zip'
      const href = 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/soft/%E6%89%93%E5%8D%B0%E6%9C%BA%E5%AE%89%E8%A3%85%E5%8C%85.zip'
      downloadFile(href)
    },
    handleLogout () {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗?',
        onOk () {
          return that.Logout({}).then(() => {
            sessionStorage.removeItem('pagePwd')
            window.location.href = '/user/login'
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    },
    handleOk () {
      if (this.passwdData.oldPassword === '') {
        notification.warning({
          message: '旧密码输入有误',
          description: '请正确输入旧密码'
        })
        return false
      }
      if (this.passwdData.newPassword === '') {
        notification.warning({
          message: '新密码输入有误',
          description: '请正确输入新密码'
        })
        return false
      }
      if (this.passwdData.checkNewPassword === '') {
        notification.warning({
          message: '确认新密码输入有误',
          description: '请正确输入确认新密码'
        })
        return false
      }
      if (this.passwdData.checkNewPassword !== this.passwdData.newPassword) {
        notification.warning({
          message: '新密码和确认密码不一致',
          description: '请正确输入确认新密码'
        })
        return false
      }
      const body = _.cloneDeep(this.passwdData)
      body['adminId'] = this.accountId()
      body['oldPassword'] = passwordEncryption(body.oldPassword)
      body['newPassword'] = passwordEncryption(body.newPassword)
      updatePasswd(body).then(res => {
        if (_.get(res, 'code') === 200) {
          this.passwdData.oldPassword = ''
          this.passwdData.newPassword = ''
          this.passwdData.checkNewPassword = ''
          this.loginTime = String((new Date()).getTime())
          notification.success({
            message: '密码修改成功',
            description: '操作成功'
          })
        }
      })
    }
  }
}
</script>
